// extracted by mini-css-extract-plugin
export default {"bannerText":"CtFOdZUOuQcVhcwwQh0I","bannerLink":"pf6aY7ZOu38cZI0kVFkj","tableFormatLink":"wDrnmU3_3MEXOKhrHijD"};